<template>
    <v-select :disabled="disabled" :label="label || 'Dias disponibles'" :value="value" v-model="weekDaysSelected" :multiple="isMultiple" :items="weekDayOptions">
        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.text }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ weekDaysSelected.length - 1 }}+)</span>
        </template>
    </v-select>
</template>

<script>
    export default{
        props: ['label', 'value', 'disabled', 'multiple'],
        mounted(){},
        data(vm){
            return {
                weekDaysSelected: this.value !== undefined && typeof this.value === 'number' ? this.value : (this.isMultiple ? [] : null),
                weekDayOptions: [
                    {
                        text: 'Lunes',
                        value: 1
                    },
                    {
                        text: 'Martes',
                        value: 2
                    },
                    {
                        text: 'Miercoles',
                        value: 3
                    },
                    {
                        text: 'Jueves',
                        value: 4
                    },
                    {
                        text: 'Viernes',
                        value: 5
                    },
                    {
                        text: 'Sábado',
                        value: 6
                    },
                    {
                        text: 'Domingo',
                        value:  0
                    },
                ],
            }
        },
        computed: {
            isMultiple(){
                return this.multiple === undefined || this.multiple === true
            }
        },
        watch:{
            value(val){
                this.weekDaysSelected = val
            },
            weekDaysSelected(val){
                this.$emit('change', val)
            }
        }
    }
</script>